// @see: https://tailwindcss.com/docs/dark-mode#toggling-dark-mode-manually

export const getTheme = () => {
  let localTheme = localStorage.getItem('theme');
  let isDark =
    localTheme === 'dark' ||
    (localTheme === null && window.matchMedia('(prefers-color-scheme: dark)').matches);
  return isDark ? 'dark' : 'light';
};

export const toggleTheme = (force = null) => {
  if (force !== null) {
    localStorage.setItem('theme', force);
  }

  let isDark = getTheme() === 'dark';
  if (isDark) {
    document.documentElement.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  } else {
    document.documentElement.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  }

  return getTheme();

  // Whenever the user explicitly chooses to respect the OS preference
  // localStorage.removeItem('theme');
};
